import { ActionContext } from 'vuex'
import RootState from '../../state'
import EditorCoreState, { DropPosition } from './state'
import { Mutations } from './helpers'

export { DropPosition }

type EditorCoreContext = ActionContext<EditorCoreState, RootState>

export async function showDropPoint(context: EditorCoreContext, position: DropPosition): Promise<void> {
  Mutations.showDropPoint(context, position)
}

/**
 * ドロップ地点を隠す。ただし、最終ドロップ地点は覚えている
 */
export async function hideDropPoint(context: EditorCoreContext): Promise<void> {
  Mutations.hideDropPoint(context)
}

/**
 * ドロップ地点を隠し、最終ドロップ地点を削除する
 */
export async function setDragEventType(context: EditorCoreContext, eventType: string): Promise<void> {
  Mutations.setDragEventType(context, eventType)
}

export default {
  showDropPoint,
  hideDropPoint,
  setDragEventType
}
